export const LOAD_RESTAURANT = 'LOAD_RESTAURANT';
export const LOAD_RESTAURANT_SUCCESS = 'LOAD_RESTAURANT_SUCCESS';
export const UPDATE_RESTAURANT = 'UPDATE_RESTAURANT';
export const SET_RESTAURANT = 'SET_RESTAURANT';
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
